module.exports = "/packs/images/pages/content_hub/find-centre~bf953917d784ac347e86d10d7fc16399.jpg";